@if (displayError) {
  <div>
    <span class="sr-only">(error)</span>
    <div class="error-msg">
      <span class="fa fa-times form-control-feedback fix-error-icon"></span>
      {{ errorMsg }}
    </div>
  </div>
}
